<template>
      <v-list-tile 
        avatar
        v-if="baby"
        @click="$router.push(`dashboard/${baby.id}`)">
        <v-list-tile-avatar>
            <v-icon v-if="baby.parent === uid">
                pregnant_woman
            </v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
            <v-list-tile-title>
                {{ baby.name }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
                {{ new Date(baby.date.seconds * 1000).toISOString().split('T')[0] }}
            </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
            <v-btn icon @click.stop="remove">
                <v-icon>delete</v-icon>
            </v-btn>
        </v-list-tile-action>
    </v-list-tile>
    <v-progress-linear v-else indeterminate />
</template>


<script>
import { firestore, ui, uiConfig, auth } from "@/firebase";
export default {
  props: {
    id: String,
    uid: String
  },
  data () {
      return {
          baby: null
      }
  },
  mounted() {
    this.$bind(
      "baby",
      firestore
        .collection("babies")
        .doc(this.id)
    );
  },
  methods: {
      remove() {

      }
  }
};
</script>
